import { render, staticRenderFns } from "./HMPriceButton.vue?vue&type=template&id=46bc675a&scoped=true&"
import script from "./HMPriceButton.vue?vue&type=script&lang=js&"
export * from "./HMPriceButton.vue?vue&type=script&lang=js&"
import style0 from "./HMPriceButton.vue?vue&type=style&index=0&id=46bc675a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bc675a",
  null
  
)

export default component.exports